import React, { useState, useEffect } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Button,
  Th,
  Td,
  Skeleton,
  Box,
  useToast,
} from "@chakra-ui/react";
import ZoneItem from "./ZoneItem";
import useFetch from "../../../hooks/useFetch";
import ConfirmationSwal from "../../../Utils/confirmationSwal";

function ZonesTable() {
  const [zones, setZones] = useState([]);
  const [showNewZone, setShowNewZone] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { get, del, post, put } = useFetch();
  const toast = useToast();

  useEffect(() => {
    getZones();
  }, []);

  const getZones = async () => {
    setIsLoading(true);
    await get("/users/zones")
      .then((res) => {
        setZones(res);
        setIsLoading(false);
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const updateZone = async (zone) => {
    await put(`/users/zones/${zone.id}`, zone)
      .then(() => {
        getZones();
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const addZone = async (zone) => {
    await post(`/users/zones`, zone)
      .then(() => {
        getZones();
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const removeZone = async (zone) => {
    ConfirmationSwal.fire({
      title: "Eliminar zona",
      text: "¿Desea eliminar la zona?",
      icon: "question",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await del(`/users/zones/${zone.id}`)
          .then(() => {
            getZones();
          })
          .catch((e) => {
            toast({
              title: "Se ha producido un error.",
              description:
                e?.message || "Contacte con el administrador del sistema.",
              status: "error",
              duration: 4000,
              isClosable: true,
            });
          });
      }
    });
  };

  return (
    <>
      <Button
        my="2"
        colorScheme="blue"
        onClick={() => setShowNewZone(true)}
        isDisabled={showNewZone}
      >
        + Zona
      </Button>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
          <Thead>
            <Tr>
              <Th fontSize="0.8em">Código</Th>
              <Th fontSize="0.8em">Nombre</Th>
              <Th fontSize="0.8em">Descripción</Th>
              <Th fontSize="0.8em">Dias de entrega</Th>
              <Th fontSize="0.8em" textAlign="center">
                Acciones
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {isLoading ? (
              <Tr>
                <Td colSpan="100%">
                  <Skeleton h="1rem" />
                </Td>
              </Tr>
            ) : (
              <>
                {showNewZone && (
                  <ZoneItem
                    zone={{}}
                    setShowNewZone={setShowNewZone}
                    addZone={addZone}
                    initialAction={"new"}
                  />
                )}
                {zones.map((zone) => (
                  <ZoneItem
                    key={zone.id}
                    zone={zone}
                    setShowNewZone={setShowNewZone}
                    updateZone={updateZone}
                    deleteZone={removeZone}
                  />
                ))}
              </>
            )}
          </Tbody>
        </Table>
      </Box>
    </>
  );
}

export default ZonesTable;
